import { render, staticRenderFns } from "./play.vue?vue&type=template&id=5713993e&scoped=true&"
import script from "./play.vue?vue&type=script&lang=js&"
export * from "./play.vue?vue&type=script&lang=js&"
import style0 from "./play.vue?vue&type=style&index=0&id=5713993e&prod&scoped=true&lang=css&"
import style1 from "./play.vue?vue&type=style&index=1&id=5713993e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5713993e",
  null
  
)

export default component.exports